if (!customElements.get("grid-toggle")) {
  class GridToggle extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", this.updatePage.bind(this)); // Bind this context

      // set view to list view if it was active before
      this.storageView =
        localStorage.getItem("gridView") ||
        localStorage.getItem("collectionView");
      this.initView();
    }

    initView() {
      const productGridContainer = document.querySelector(
        "#ProductGridContainer",
      );
      const filterGridContainer = document.querySelector(".facets-wrapper");

      if (this.storageView?.includes("list") || this.storageView === "list") {
        if (productGridContainer)
          productGridContainer.setAttribute("data-view", "list");
        if (filterGridContainer)
          filterGridContainer.setAttribute("data-view", "list");
        this.querySelector("[id^='radio-list']")?.setAttribute("checked", true);
        const listRadio = this.querySelector("[id^='radio-list']");
        const tilesRadio = this.querySelector("[id^='radio-tiles']");
        if (listRadio) listRadio.checked = true;
        if (tilesRadio) tilesRadio.checked = false;
      } else {
        if (productGridContainer)
          productGridContainer.setAttribute("data-view", "tiles");
        if (filterGridContainer)
          filterGridContainer.setAttribute("data-view", "tiles");
        const listRadio = this.querySelector("[id^='radio-list']");
        const tilesRadio = this.querySelector("[id^='radio-tiles']");
        if (tilesRadio) tilesRadio.checked = true;
        if (listRadio) listRadio.checked = false;
      }
    }

    updatePage() {
      // Get fresh references each time to avoid stale DOM issues after AJAX
      const productGridContainer = document.querySelector(
        "#ProductGridContainer",
      );
      const filterGridContainer = document.querySelector(".facets-wrapper");
      const remoteFilterButton = document.querySelector("remote-filter-button");
      const tilesView = document.querySelector(".tiles-view");
      const listView = document.querySelector(".list-view");

      // Update value
      this.currentValue = this.querySelector("input:checked")?.id;
      // store in local storage for pagination
      localStorage.setItem("gridView", this.currentValue);
      localStorage.setItem(
        "collectionView",
        this.currentValue.includes("list") ? "list" : "tiles",
      );

      // List view
      if (this.currentValue.includes("list")) {
        if (productGridContainer)
          productGridContainer.setAttribute("data-view", "list");
        if (filterGridContainer)
          filterGridContainer.setAttribute("data-view", "list");
        if (remoteFilterButton)
          remoteFilterButton.setAttribute("data-view", "list");
        if (tilesView) tilesView.style.display = "none";
        if (listView) listView.style.display = "block";
      }

      // Tiles view
      if (this.currentValue.includes("tiles")) {
        if (productGridContainer)
          productGridContainer.setAttribute("data-view", "tiles");
        if (filterGridContainer)
          filterGridContainer.setAttribute("data-view", "tiles");
        if (remoteFilterButton)
          remoteFilterButton.setAttribute("data-view", "tiles");
        if (tilesView) tilesView.style.display = "block";
        if (listView) listView.style.display = "none";
      }
    }
  }

  customElements.define("grid-toggle", GridToggle);
}

// button that clicks on the filterbutton for mobile devices
if (!customElements.get("remote-filter-button")) {
  class RemoteFilterButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickButton.bind(this));
      // window.addEventListener("resize",this.checkFixedPosition().bind(this))
    }
    clickButton() {
      document
        .querySelector(".mobile-facets__open-wrapper#Open-filter-button")
        .click();
      this.classList.add("active");
    }
  }
  customElements.define("remote-filter-button", RemoteFilterButton);
}

if (!customElements.get("sticky-filter-buttons")) {
  class stickyFilterButtons extends HTMLElement {
    constructor() {
      super();
      this.menu = document.querySelector("header");
      // Init Position
      this.top = this.menu.getBoundingClientRect().bottom + "px";
      this.old_top = this.top;
      this.style.top = this.top;
      window.addEventListener("DOMContentLoaded", this.setPosition.bind(this));
      window.addEventListener("scroll", this.setPosition.bind(this));
      this.lastWidth = window.innerWidth;

      window.addEventListener("resize", () => {
        if (window.innerWidth !== this.lastWidth) {
          this.lastWidth = window.innerWidth;
          this.setPosition.bind(this);
        }
      });
    }
    setPosition() {
      this.top = this.menu.getBoundingClientRect().bottom + "px";
      if (this.top != this.old_top) {
        this.old_top = this.top;
        this.style.top = this.top;
      }
    }
  }
  customElements.define("sticky-filter-buttons", stickyFilterButtons);
}
